import { IconCategory } from './types';
import { Arrow, Basic, Brand, Edit, Home, Menu, Misc } from './maps';
export const Icons = {
    [IconCategory.Arrow]: Arrow,
    [IconCategory.Basic]: Basic,
    [IconCategory.Brand]: Brand,
    [IconCategory.Edit]: Edit,
    [IconCategory.Home]: Home,
    [IconCategory.Menu]: Menu,
    [IconCategory.Misc]: Misc,
};
//# sourceMappingURL=icons.js.map